import clsx from 'clsx'
import Link from 'next/link'
import React, { useCallback } from 'react'
import type { SocialResult } from '../../data/SocialFragment'
import SvgFacebook from '../../svg/icons/Facebook'
import SvgInstagram from '../../svg/icons/Instagram'
import SvgTwitter from '../../svg/icons/Twitter'
import style from './SocialRow.module.sass'

export type SocialRowProps = {
	iconsColoredPrimary?: boolean
	socials: SocialResult[]
	isAlignedLeft?: boolean
}

export const SocialRow = React.memo(function SocialRow(props: SocialRowProps) {
	const setIcon = useCallback((label: string) => {
		switch (label) {
			case 'facebook':
				return <SvgFacebook />
			case 'instagram':
				return <SvgInstagram />
			case 'twitter':
				return <SvgTwitter />
		}
	}, [])

	return (
		<div className={clsx(style.socialRow, props.isAlignedLeft && style.socialRowAlignedLeft)}>
			{props.socials?.map(
				(social) =>
					social.link && (
						<Link
							title={social.label}
							key={social.id}
							href={social.link}
							target="_blank"
							aria-label={social.label}
							className={clsx(style.social, style.iconWrapper, props.iconsColoredPrimary && style.iconWrapperPrimary)}
						>
							{setIcon(social.label)}
						</Link>
					),
			)}
		</div>
	)
})
